import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import transformContentfulResponse from '../utils/transformContentfulResponse';
export var fetchCdpWeekSpeakerLandingPage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, speakersLimit, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/content/filter/cdpWeekSpeakerSessions?featured=true&limit=".concat(speakersLimit), options);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.items.map(function (record) {
              var _record$speakerHeadsh, _record$speakerHeadsh2, _record$speakerHeadsh3;

              return _objectSpread(_objectSpread({}, record), {}, {
                speakerHeadshot: {
                  src: (_record$speakerHeadsh = record.speakerHeadshot) === null || _record$speakerHeadsh === void 0 ? void 0 : (_record$speakerHeadsh2 = _record$speakerHeadsh.file) === null || _record$speakerHeadsh2 === void 0 ? void 0 : _record$speakerHeadsh2.url,
                  title: (_record$speakerHeadsh3 = record.speakerHeadshot) === null || _record$speakerHeadsh3 === void 0 ? void 0 : _record$speakerHeadsh3.title
                }
              });
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCdpWeekSpeakerLandingPage(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchCdpWeekAgendaPage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client, options) {
    var res, response, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("/content/entries/cdpWeekAgendaItem", options);

          case 2:
            res = _context2.sent;
            response = res.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                speaker: item.speaker.map(function (speaker) {
                  var _speaker$fields$speak, _speaker$fields$speak2, _speaker$fields$speak3, _speaker$fields$speak4, _speaker$fields$speak5;

                  return _objectSpread(_objectSpread({}, speaker.fields), {}, {
                    speakerHeadshot: {
                      src: (_speaker$fields$speak = speaker.fields.speakerHeadshot) === null || _speaker$fields$speak === void 0 ? void 0 : (_speaker$fields$speak2 = _speaker$fields$speak.fields) === null || _speaker$fields$speak2 === void 0 ? void 0 : (_speaker$fields$speak3 = _speaker$fields$speak2.file) === null || _speaker$fields$speak3 === void 0 ? void 0 : _speaker$fields$speak3.url,
                      title: (_speaker$fields$speak4 = speaker.fields.speakerHeadshot) === null || _speaker$fields$speak4 === void 0 ? void 0 : (_speaker$fields$speak5 = _speaker$fields$speak4.fields) === null || _speaker$fields$speak5 === void 0 ? void 0 : _speaker$fields$speak5.title
                    }
                  });
                })
              });
            });
            data = {
              featured: response.filter(function (item) {
                return item.featuredSession;
              })[0],
              items: response
            };
            return _context2.abrupt("return", transformContentfulResponse(_objectSpread({}, data)));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCdpWeekAgendaPage(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchCdpWeekSpeakerPage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(client, options) {
    var response, speakersOrder, landingPageSpeakers, finalResponse;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return client.get("/content/filter/cdpWeekSpeakerSessions", options);

          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return client.get("/content/entries/cdpWeekSpeakerLandingPage");

          case 5:
            speakersOrder = _context3.sent;
            landingPageSpeakers = speakersOrder[0].speakerOrder.map(function (e) {
              return e.fields;
            });
            finalResponse = landingPageSpeakers.reduce(function (acc, landingPageSpeaker) {
              var sessionSpeaker = response.items.find(function (e) {
                return e.speakerName === landingPageSpeaker.speakerName;
              });

              if (!sessionSpeaker) {
                var _landingPageSpeaker$s;

                landingPageSpeaker.sessions = [{
                  sessionTitle: "",
                  featuredSession: false,
                  sessionDescription: "",
                  shortDescription: "",
                  sessionDateTimePdt: ""
                }];
                landingPageSpeaker.speakerHeadshot = (_landingPageSpeaker$s = landingPageSpeaker.speakerHeadshot) === null || _landingPageSpeaker$s === void 0 ? void 0 : _landingPageSpeaker$s.fields;
                return {
                  items: [].concat(_toConsumableArray(acc.items), [landingPageSpeaker])
                };
              }

              return {
                items: [].concat(_toConsumableArray(acc.items), [sessionSpeaker])
              };
            }, {
              items: []
            });
            return _context3.abrupt("return", finalResponse.items.map(function (record) {
              var _record$speakerHeadsh4, _record$speakerHeadsh5, _record$speakerHeadsh6;

              return _objectSpread(_objectSpread({}, record), {}, {
                speakerHeadshot: {
                  src: (_record$speakerHeadsh4 = record.speakerHeadshot) === null || _record$speakerHeadsh4 === void 0 ? void 0 : (_record$speakerHeadsh5 = _record$speakerHeadsh4.file) === null || _record$speakerHeadsh5 === void 0 ? void 0 : _record$speakerHeadsh5.url,
                  title: (_record$speakerHeadsh6 = record.speakerHeadshot) === null || _record$speakerHeadsh6 === void 0 ? void 0 : _record$speakerHeadsh6.title
                }
              });
            }));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchCdpWeekSpeakerPage(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();